/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  if (!customElements.get('upsell-product')) {
    class UpsellProduct extends HTMLElement {
      connectedCallback() {
        // Wait for next frame to ensure layout is calculated
        requestAnimationFrame(() => {
          this.setImageWidth();
        });

        // Re-calculate on resize
        this.resizeHandler = () => {
          this.setImageWidth();
        };
        window.addEventListener('resize', this.resizeHandler);
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.resizeHandler);
      }

      setImageWidth() {
        const productUpsell = this.querySelector('.product-upsell');

        if (productUpsell) {
          const height = productUpsell.offsetHeight;
          productUpsell.style.setProperty('--UPSELLS-IMAGE-WIDTH', `${height}px`);
        }
      }
    }

    customElements.define('upsell-product', UpsellProduct);
  }




  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
